<template>
  <div class="columns is-multiline stadistics" v-if="!loading">
    <div class="column is-12">
      <p class="subtitle">Leads (Web)</p>
    </div>

    <div class="column is-4">
      <div class="box is-relative">
        <p class="dashtitle">Leads totales</p>
        <p class="dashAmount">{{ formatNumber(leads.countLeads) }}</p>
        <a
          class="navbar-item is-absolute"
          @click="redirectLeads()"
          style="position: absolute; right: 0; bottom: 0;margin: 10px;"
        >
          <i class="material-icons">list_alt</i>
        </a>
      </div>
    </div>

    <div class="column is-4">
      <div class="box is-relative">
        <p class="dashtitle">Leads unicos (sin duplicados)</p>
        <p class="dashAmount">{{ formatNumber(leads.countUniqueLeads) }}</p>
      </div>
    </div>

    <div class="column is-4">
      <div class="box is-relative">
        <p class="dashtitle">Leads sin contactar</p>
        <p class="dashAmount">{{ formatNumber(leads.countNotContacted) }}</p>
        <a
          class="navbar-item is-absolute"
          @click="redirectLeads({ contacted: 'no' })"
          style="position: absolute; right: 0; bottom: 0;margin: 10px;"
        >
          <i class="material-icons">list_alt</i>
        </a>
      </div>
    </div>

    <div class="column is-4">
      <div class="box is-relative">
        <p class="dashtitle">Leads en 2do / 3er toque</p>
        <p class="dashAmount">{{ formatNumber(leads.countFollowUp) }}</p>
      </div>
    </div>

    <div class="column is-4">
      <div class="box is-relative">
        <p class="dashtitle">Leads que cerraron venta</p>
        <p class="dashAmount">{{ formatNumber(leads.countClosedSale) }}</p>
        <a
          class="navbar-item is-absolute"
          @click="redirectLeads({ status: 'cerro-venta' })"
          style="position: absolute; right: 0; bottom: 0;margin: 10px;"
        >
          <i class="material-icons">list_alt</i>
        </a>
      </div>
    </div>

    <div class="column is-4">
      <div class="box is-relative">
        <p class="dashtitle">Leads rechazados</p>
        <p class="dashAmount">{{ formatNumber(leads.countRejected) }}</p>
        <a
          class="navbar-item is-absolute"
          @click="redirectLeads({ status: 'rechazado' })"
          style="position: absolute; right: 0; bottom: 0;margin: 10px;"
        >
          <i class="material-icons">list_alt</i>
        </a>
      </div>
    </div>
  </div>
  <div v-else>
    <loading-component />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'LeadsStadistics',
  data () {
    return {
      leads: {},
      loading: false
    }
  },
  props: {
    dateSegmentation: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    LoadingComponent: () => import('@/components/ui/Loading')
  },
  watch: {
    dateSegmentation (newData) {
      this.updateLeadsStadistics(newData)
    }
  },
  methods: {
    ...mapActions(['getLeadsStadistics', 'getLeadsStadisticsSegmentation']),
    updateLeadsStadistics (newData) {
      this.loading = true

      // Sin rango de fechas se muestra el acumulado historico, igual que el
      // resto de las tarjetas del Home.
      if (!newData || !newData.start || !newData.end) return this.getLeadsDefaultData()

      const date = {
        start: moment(newData.start).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        end: moment(newData.end).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      }

      this.getLeadsStadisticsSegmentation(date)
        .then(data => {
          if (data) this.leads = data
          this.loading = false
        })
        .catch(error => {
          console.error('Error al obtener las estadisticas de leads del periodo:', error)
          this.loading = false
        })
    },
    getLeadsDefaultData () {
      this.getLeadsStadistics()
        .then(data => {
          if (data) this.leads = data
          this.loading = false
        })
        .catch(error => {
          console.error('Error al obtener las estadisticas de leads:', error)
          this.loading = false
        })
    },
    formatNumber (value) {
      return value ? parseFloat(value).toLocaleString('en', { maximumFractionDigits: 0 }) : 0
    },
    redirectLeads (filters = {}) {
      const query = { page: 1, ...filters }
      const { start, end } = this.dateSegmentation || {}

      if (start && end) {
        query.startDate = moment(start).format('YYYY-MM-DD')
        query.endDate = moment(end).format('YYYY-MM-DD')
      }

      this.$router.push({ name: 'leads', query }).catch(err => {
        if (err.name !== 'NavigationDuplicated') console.error(err)
      })
    }
  },
  beforeMount () {
    this.updateLeadsStadistics(this.dateSegmentation)
  }
}
</script>

<style scoped>
  .dashtitle {
    font-size: 14px;
    text-align: center;
  }
  .dashAmount {
    font-size: 28px;
    font-weight: bolder;
    margin-top: 3px;
    text-align: center;
  }
  .stadistics .box:hover {
    background-color: #FAFAFA;
  }
</style>
